import React from 'react'
import { Link } from 'react-router-dom'

function page() {
  return (
    <>
      <section className="footer-section" style={{ overflowY: "hidden" }}>
        <div className="footer-inner text-center">
          <div className="logo">
            <Link to="/">
              <img
                src="/assets/images/logo-text.png"
                className="logo-text d-xxl-block  "
                alt="logo-text"
              />
            </Link>
          </div>
          <div className="text-sec">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/termsconditions">Terms & Conditions</Link>
            <Link to="/triviafun">Trivia Fun</Link>
          </div>
        </div>
      </section>
      <section
        className="footer-sec-main"
        style={{ marginBottom: 0, height: "auto" }}
        // style={{paddingBottom:"2%", overflowY:"hidden" }}
      >
        <div className="container">
          <div className="footer-sec-flex">
            <div className="d-flex gap-2">
              {/* <span>
                Copyright © 2024. Designed by{" "}
                <a href="https://webmobril.com/" target="_blank">
                  Webmobril Technologies
                </a>{" "}
                All rights reserved.
              </span> */}

              <span>Our Social Media Presence </span>
              <div className="">
                <ul className="d-flex gap-4 social-area">
                  <li>
                    <a
                      href="https://www.facebook.com/"
                      aria-label="Facebook"
                      className="d-center"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/"
                      aria-label="Instagram"
                      className="d-center"
                    >
                      <i class="fab fa-youtube"></i>
                    </a>
                  </li>
                  {/* <li>
                  <a
                    href="https://www.linkedin.com/"
                    aria-label="Linkedin"
                    className="d-center"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/"
                    aria-label="Twitter"
                    className="d-center"
                  >
                    <i class="fa-brands fa-x-twitter"></i>
                  </a>
                </li> */}
                </ul>
              </div>
            </div>

            <div className="">
              {/* <span>
                Copyright © 2024. Designed by{" "}
                <a href="https://webmobril.com/" target="_blank">
                  Webmobril Technologies
                </a>{" "}
                All rights reserved.
              </span> */}

              <span>
                <a href="https://discord.com/invite/D8J4kughMB" target="_blank">
                  Official Discord Channel
                </a>{" "}
              </span>
            </div>
            <div className="">
              <span>
                {/* Copyright © 2024. Designed by{" "} */}
                <a
                  href="https://membersnew.weshareabundance.com/login"
                  target="_blank"
                >
                  We Share Abundance.
                </a>{" "}
                All rights reserved.
              </span>
            </div>
          </div>
        </div>
      </section>
      {/* <button
        className="scrollToTop d-none d-md-flex d-center"
        aria-label="scroll Bar Button"
      >
        Back To Top
      </button> */}
    </>
  );
}

export default page
